import { appstr } from "@coreapp/utils/appstr";
import { GetDateFormatStrList } from "@coreapp/utils/GetDateFormatStrList";
import {
  AccountSettingsSectionRoutes,
  getAccountSettingsTestPrefix
} from "@/providers/NavigationProvider";

const themeTestPrefix = getAccountSettingsTestPrefix(AccountSettingsSectionRoutes.Theme);

export const BuildDateFormatOptions = clickHandler => {
  const dateList = GetDateFormatStrList();
  return (
    dateList?.map((date, index) => {
      return {
        label: date,
        value: parseInt(index),
        clickHandler: clickHandler,
        dataTestId: `${themeTestPrefix}-date-format-option-${date}`
      };
    }) || []
  );
};

export const BuildFontOptions = (fonts, clickHandler) => {
  return (
    fonts?.map(font => {
      return { label: font, value: font, clickHandler: clickHandler };
    }) || []
  );
};

const getColorLabel = color => {
  if (typeof color === "object") {
    return appstr("gradientfill");
  }

  return color.toUpperCase();
};

export const BuildColorOptions = colorsList => {
  return (
    colorsList?.map(color => {
      return { label: getColorLabel(color), value: color };
    }) || []
  );
};

export const commonSelectProps = {
  listWidth: "small",
  size: "small",
  optionSize: "small"
};

export const commonButtonProps = {
  modifier: "primary",
  size: "small"
};
